import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import {
  Modal,
  ModalContent,
  ModalClose,
  Button,
  IconLogoCombined,
} from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { FREE_TRIAL_I18N_NAMESPACE } from '../../../i18n'
import { useFreeTrial } from '../../../lib'

export const TrialNoLongerAvailableModal = () => {
  const [show, setShow] = useState<boolean>(false)
  const { t } = useTranslation(FREE_TRIAL_I18N_NAMESPACE)
  const isTrialNoLongerAvailable = useIsTrialNoLongerAvailable()
  const handleClose = () => {
    setShow(false)
    // Reload the page to get the right experimentation context for the user (E.G: Promo is not active
    // for free trial users, so reloading the page will enable them to see the promo)
    window.location.reload()
  }

  useEffect(() => {
    if (isTrialNoLongerAvailable) {
      setShow(true)

      Cookies.remove('referral_token')
      Cookies.remove('referral_token_no_longer_valid_error')
    }
  }, [isTrialNoLongerAvailable])

  return (
    <Modal size='small' show={show} onClose={handleClose}>
      <ModalContent
        aria-label={t('common.shared.modal.noLongerAvailable.title')}
        className='mc-bg-light'
      >
        <div className='mc-theme-light mc-px-5 mc-py-9 mc-text--center'>
          <ModalClose />
          <IconLogoCombined
            className='mc-mb-4 mc-text-color--dark mc-icon--scale-11'
            viewBox='0 0 66 50'
          />

          <h1 className='mc-mb-3 mc-text-h4'>
            {t('common.shared.modal.noLongerAvailable.title')}
          </h1>

          <p className='mc-mb-8 mc-px-6'>
            {t('common.shared.modal.noLongerAvailable.subtitle')}
          </p>

          <Button focusable fullWidth onClick={handleClose}>
            {t('common.shared.modal.noLongerAvailable.cta')}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  )
}

const useIsTrialNoLongerAvailable = () => {
  const { trial } = useFreeTrial()
  const referralTokenCookie = Cookies.get('referral_token')
  const referralTokenNoLongerValidErrorCookie = Cookies.get(
    'referral_token_no_longer_valid_error',
  )

  return (
    !trial?.eligible &&
    (!!referralTokenCookie || !!referralTokenNoLongerValidErrorCookie)
  )
}
